import { render, staticRenderFns } from "./AddNewSidePanel.vue?vue&type=template&id=28648830&scoped=true&"
import script from "./AddNewSidePanel.vue?vue&type=script&lang=ts&"
export * from "./AddNewSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28648830",
  null
  
)

export default component.exports